<template>
  <Iterator :items="docs" title="Tutorials" :displayItem="displayComponent"/>
</template>

<script>
import axiosInstances from "@/../../coreui/server/axiosInstances"
import { sync } from 'vuex-pathify'
import axios from 'axios'
import Iterator from '@/../../coreui/components/Iterator'
import DisplayVideos from './DisplayVideos'
export default {
  components: {
    Iterator,
    DisplayVideos
  },
  data() {
    return {
      docs: [],
      displayComponent: DisplayVideos
    };
  },
  computed: {
    user: sync('login/loggedinUser')
  },
  methods: {
    async getDocs() {
      // get items from the server
      let res = await axiosInstances.loginServer.get("/dt/v1/auth_doc?type=video")
      if (res != null && res.data != null) {
        this.docs = res.data
        console.log(this.docs)
      }
    },
  },
  created() {
    this.getDocs();
  },
  mounted() {
  },
};
</script>
<style >
</style>